import { useQuery } from 'react-query';
import { getMGList } from 'services/parametersService';

export const useGetManagementCompanies = () =>
  useQuery('/getMGList', () => getMGList().then((res) => res.list || []).catch((res) => []), {
    staleTime: MINUTE,
  });

const SECOND = 1000;
const MINUTE = 60 * SECOND;
